import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_BRAND_BOOSTED_PETITIONS = defineFcm('brand_boosted_petitions')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				petition_ids: {
					type: 'array',
					shape: {
						type: 'number',
					},
				},
			},
		}),
	)
	.withDefault(undefined)
	.withMerger(({ localeValue, countryValue }) => {
		if (localeValue && countryValue) {
			const localeIds = new Set(localeValue.petition_ids);
			return { petition_ids: countryValue.petition_ids.filter((id) => localeIds.has(id)) };
		}
		return undefined;
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: ['comms-stack', 'corgi-front-end'],
		context: 'Brand Boosted Petitions',
		description:
			'List of petition IDs that are boosted brand campaigns by MarComms staff. Locale configuration only applies to the site, not comms stack.',
		mergeLogic:
			'On the site, it returns the intersection of locale and country petition IDs (only IDs present in both). Returns undefined if either value is absent.',
		import: false,
		template: {
			petition_ids: [491164774],
		},
	});
